import PropTypes from "prop-types";
import React, { useState } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import api from '../../helpers/api'

// import images
import logo from "../../assets/images/white logo png.png";

const Login = props => {
  document.title = "Login | Arcmedix";


  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      identifier: '',
      password: '',
    },
    validationSchema: Yup.object({
      identifier: Yup.string().required("Please enter your username or email"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);
      
      try {
        // Replace this with your actual login API call
        const response = await api.post('auth/login',values);
        if (response.status === 200) {
          const { token, username, role, roles, permissions } = response.data.response;

          // Only allow super admins to access the admin app
          if (role !== 'ROLE_SUPER_ADMIN') {
            setError('Access denied. Only super administrators can access this application.');
            return;
          }

          // Store token separately
          localStorage.setItem('token', token);

          // Store user info including full RBAC roles and permissions
          localStorage.setItem('authUser', JSON.stringify({ username, role, roles, permissions }));
          navigate('/organizations');
        }        
         else {
          setError(response.message || "Login failed");
        }
      } catch (err) {
        if (err.response?.status === 401) {
          setError('Invalid credentials');
        } else {
          setError(err.response?.data?.message || err.message || 'An error occurred during login');
        }
      } finally {
        setLoading(false);
      }
    }
  });

  return (
    <React.Fragment>
      <div className="authentication-bg min-vh-100">
        <div className="bg-overlay"></div>
        <Container>
          <div className="d-flex flex-column min-vh-100 px-3">
            <Row className="justify-content-center my-auto">
              <Col md={8} lg={6} xl={5}>
                <div className="text-center">
                  <Link to="/">
                    <img src={logo} alt="" height="90" width='200'/>
                  </Link>
                </div>
                <Card>
                  <CardBody className="p-4">
                    <div className="text-center">
                      <h5 className="text-primary">Welcome Back !</h5>
                      <p className="text-muted">Sign in to continue to Arcmedix</p>
                    </div>
                    <div className="p-2 mt-4">
                      <Form className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}>
                        {error ? <Alert color="danger"><div>{error}</div></Alert> : null}
                        <div className="mb-3">
                          <Label className="form-label">Username or Email</Label>
                          <Input
                            name="identifier"
                            className="form-control"
                            placeholder="Enter username or email"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.identifier || ""}
                            invalid={
                              validation.touched.identifier && validation.errors.identifier ? true : false
                            }
                          />
                          {validation.touched.identifier && validation.errors.identifier ? (
                            <FormFeedback type="invalid"><div>{validation.errors.identifier}</div></FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Password</Label>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password && validation.errors.password ? true : false
                            }
                          />
                          {validation.touched.password && validation.errors.password ? (
                            <FormFeedback type="invalid"><div> {validation.errors.password} </div></FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-3 text-center">
                          <button 
                            className="btn btn-primary w-sm waves-effect waves-light" 
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? 'Logging in...' : 'Log In'}
                          </button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className="text-center text-muted p-4">
                  <p className="text-white-50">Copyright © {new Date().getFullYear()} Arcmedix. All rights reserved</p>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};